// import load from '@pandasekh/dynamic-script-loader';

export const finnAnsattFront = (clientId) => {

  loadExternalScript("//prokomresources.prokomcdn.no/plugins/ansattliste/dist/ansattliste.min.js").then(() => {
    var employeelistTarget = document.getElementById("employeeListModule");
    var txt = document.createElement("textarea");
    txt.innerHTML = "";
    var avd = txt.value;
    var initusers = true;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const param = urlParams.get('avd');

    if (param != null && param != "") {
      avd = param;
    }

    if (param == "alle") {
      initusers = false;
      avd = "";
    }

    if (employeelistTarget && SSPEmployeeList) {
      SSPEmployeeList({
        target: employeelistTarget,
        url: "https://servio.ansatt.prokom.no",
        clientId: clientId,
        defaultDepartment: avd,
        noInitUsers: initusers,
        config: {
          search: {
            "Search": {
              "TypeOfSearch": "Contains",
              "SearchFields": [
                "SurName",
                "GivenName",
                "Title",
                "Department",
                "Section",
                "Phone"]
            },
            "Department": {
              "DepartmentId": "",
              "SectionId": ""
            },
            "Sort": {
              "SortField": "",
              "SortDirection": ""
            },
            "Pageing": {
              "PageSize": 50
            },
            "SearchQuery": ""
          }
        }
      });
    }

    waitForElement('.employee_register__row', (id, elem) => {
      document.querySelector('.employee_register__header').appendChild(elem);
      document.querySelector('.employee_register__filters').remove();
      elem.setAttribute('aria-expanded', 'true');
      elem.setAttribute('aria-label', 'Søk');
      const label1 = document.querySelector("label[for='employee_register--select_department']")
      const label2 = document.querySelector("label[for='employee_register--select_section']")
      label1.textContent = "Velg enhet"
      label2.textContent = "Velg avdeling"
    });

  });

  return `
    <div id="employeeListModule">
      &nbsp;
    </div>`;
};

function loadExternalScript (src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
}

function waitForElement (elementId, callBack) {
  window.setTimeout(function () {
    var element = document.querySelector(elementId);
    if (element) {
      callBack(elementId, element);
    } else {
      waitForElement(elementId, callBack);
    }
  }, 300)
}
